module.exports = __webpack_public_path__ + "media/images/top/rank2-184d655da33afb7f82afdb89de47fc34.gif";